export const PROCESS_STATUS = {
  LOGIN: 0,
  PERSONAL_DATA: 1,
  TRANSFER_TYPE: 2,
  STOCKS: 3,
  SUMMARY: 4,
  DONE: 5
} as const;
